import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatCurrency, generateId, shortHandDateTime } from '../../../utility/functions';
import Table from '../../../table/Table';

const RedeemedAppWash = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.mobile.redeemed,
        isReport: true,
        headers: [
            {
                label: 'Code',
                propKey: 'code',
            }, {
                label: 'Redeemed Date',
                propKey: 'time',
                type: 'dateTime'
            }, {
                label: 'Wash',
                propKey: 'itemName',
                options: true
            }, {
                label: 'Price',
                propKey: 'codePurchasePrice',
                type: 'number'
            }, {
                label: 'Location',
                propKey: 'locationName',
                options: true
            }, {
                label: 'Terminal',
                propKey: 'terminal',
                options: true
            }, {
                label: 'Model',
                propKey: 'model',
                options: true
            }, {
                label: 'Code Type',
                propKey: 'codeType',
                options: true
            },
        ],
        quickSort: [
            {
                label: 'Single Washes',
                propKey: 'codeType',
                query: 'Single Wash',
                color: '#8cce44',
            }, {
                label: 'Bundles',
                propKey: 'codeType',
                query: 'Wash Bundle',
                color: '#3890fe',
            },
        ],
        sticker: [
            {
                label: 'Total Redeemed at Location',
                color: '#30b866',
                callback: (data) => data.length
            }, {
                label: 'Total Redeemed',
                color: '#21D59B',
                callback: (data) => formatCurrency(data.reduce((a, b) => (b.codePurchasePrice || 0) + a, 0))
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.code}</td>
                <td>{shortHandDateTime(e.time)}</td>
                <td>{e.itemName}</td>
                <td>{formatCurrency(e.codePurchasePrice || 0)}</td>
                <td>{e.locationName}</td>
                <td>{e.terminal}</td>
                <td>{e.model}</td>
                <td>{e.codeType}</td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default RedeemedAppWash;